import { render, staticRenderFns } from "./AddTelegramAccount.vue?vue&type=template&id=be605c74"
import script from "./AddTelegramAccount.vue?vue&type=script&lang=js"
export * from "./AddTelegramAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports